module.exports = __webpack_public_path__ + "img/newjoinee.a87ef757.svg";